export const nvidiaModels = {
    id: "nvidia",
    name: "Nvidia",
    api: "https://integrate.api.nvidia.com/v1",
    npm: "@ai-sdk/openai-compatible",
    doc: "https://docs.api.nvidia.com/nim/",
    env: ["NVIDIA_API_KEY"],
    models: {
        "mistral-small-3.1-24b-instruct-2503": {
            id: "mistral-small-3.1-24b-instruct-2503",
            name: "Mistral-Small-3.1-24B-Instruct-2503",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2023-10",
            release_date: "2025-04-01",
            last_updated: "2025-09-05",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 8192,
            },
        },
        "llama-3.3-nemotron-super-49b-v1.5": {
            id: "llama-3.3-nemotron-super-49b-v1.5",
            name: "Llama-3.3-Nemotron-Super-49B-v1.5",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2023-12",
            release_date: "2025-07-25",
            last_updated: "2025-09-05",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 131072,
                output: 8192,
            },
        },
        "qwen3-235b-a22b": {
            id: "qwen3-235b-a22b",
            name: "Qwen3-235B-A22B",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-12",
            release_date: "2024-12-01",
            last_updated: "2025-09-05",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 131072,
                output: 8192,
            },
        },
        "deepseek-v3.1": {
            id: "deepseek-v3.1",
            name: "DeepSeek V3.1",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-07",
            release_date: "2025-08-20",
            last_updated: "2025-08-26",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 8192,
            },
        },
        "flux_1-dev": {
            id: "flux_1-dev",
            name: "FLUX.1-dev",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: false,
            knowledge: "2024-08",
            release_date: "2024-08-01",
            last_updated: "2025-09-05",
            modalities: {
                input: ["text"],
                output: ["image"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 4096,
                output: 0,
            },
        },
        "cosmos-nemotron-34b": {
            id: "cosmos-nemotron-34b",
            name: "Cosmos Nemotron 34B",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: false,
            knowledge: "2024-01",
            release_date: "2024-01-01",
            last_updated: "2025-09-05",
            modalities: {
                input: ["text", "image", "video"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 131072,
                output: 8192,
            },
        },
        "whisper-large-v3": {
            id: "whisper-large-v3",
            name: "Whisper Large v3",
            attachment: false,
            reasoning: false,
            temperature: false,
            tool_call: false,
            knowledge: "2023-09",
            release_date: "2023-09-01",
            last_updated: "2025-09-05",
            modalities: {
                input: ["audio"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 0,
                output: 4096,
            },
        },
        "qwen3-coder-480b-a35b-instruct": {
            id: "qwen3-coder-480b-a35b-instruct",
            name: "Qwen3 Coder 480B A35B Instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-07-23",
            last_updated: "2025-07-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 262144,
                output: 66536,
            },
        },
        "phi-4-multimodal-instruct": {
            id: "phi-4-multimodal-instruct",
            name: "Phi-4-Multimodal-Instruct",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-12",
            release_date: "2024-12-01",
            last_updated: "2025-09-05",
            modalities: {
                input: ["text", "image", "audio"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 131072,
                output: 8192,
            },
        },
        "parakeet-tdt-0.6b-v2": {
            id: "parakeet-tdt-0.6b-v2",
            name: "Parakeet TDT 0.6B v2",
            attachment: false,
            reasoning: false,
            temperature: false,
            tool_call: false,
            knowledge: "2024-01",
            release_date: "2024-01-01",
            last_updated: "2025-09-05",
            modalities: {
                input: ["audio"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 0,
                output: 4096,
            },
        },
        "llama-3.1-nemotron-ultra-253b-v1": {
            id: "llama-3.1-nemotron-ultra-253b-v1",
            name: "Llama-3.1-Nemotron-Ultra-253B-v1",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-07",
            release_date: "2024-07-01",
            last_updated: "2025-09-05",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 131072,
                output: 8192,
            },
        },
        "deepseek-r1": {
            id: "deepseek-r1",
            name: "DeepSeek R1",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: false,
            knowledge: "2024-11",
            release_date: "2024-11-01",
            last_updated: "2025-09-05",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 131072,
                output: 8192,
            },
        },
        "nemoretriever-ocr-v1": {
            id: "nemoretriever-ocr-v1",
            name: "NeMo Retriever OCR v1",
            attachment: false,
            reasoning: false,
            temperature: false,
            tool_call: false,
            knowledge: "2024-01",
            release_date: "2024-01-01",
            last_updated: "2025-09-05",
            modalities: {
                input: ["image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 0,
                output: 4096,
            },
        },
        "gemma-3-27b-it": {
            id: "gemma-3-27b-it",
            name: "Gemma-3-27B-IT",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-12",
            release_date: "2024-12-01",
            last_updated: "2025-09-05",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 131072,
                output: 8192,
            },
        },
    },
};
export default nvidiaModels;
//# sourceMappingURL=nvidia.js.map